import { render, staticRenderFns } from "./assetmap.component.vue?vue&type=template&id=1b81bd7c&scoped=true"
import script from "./assetmap.component.vue?vue&type=script&lang=js"
export * from "./assetmap.component.vue?vue&type=script&lang=js"
import style0 from "./assetmap.component.vue?vue&type=style&index=0&id=1b81bd7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b81bd7c",
  null
  
)

export default component.exports